import { features } from "@/mocks/home";

export default function FeaturesSection() {
  return (
    <section className="py-24 lg:py-32 max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="mb-16">
        <div className="text-[#00ff88] text-xs tracking-[0.3em] uppercase font-semibold mb-4 font-inter">What We Do</div>
        <h2 className="text-4xl lg:text-5xl font-black text-white tracking-tight mb-4 font-syne">Our Core Domains</h2>
        <p className="text-white/40 text-base max-w-xl font-inter">
          From building hit games to managing thriving guilds, AWWAL covers every dimension of the digital gaming world.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 rounded-sm overflow-hidden">
        {features.map((f, i) => (
          <div
            key={i}
            className="bg-[#0f0f0f] p-8 group hover:bg-[#141414] transition-colors cursor-pointer relative overflow-hidden"
          >
            <div
              className="absolute top-0 left-0 right-0 h-px opacity-0 group-hover:opacity-100 transition-opacity"
              style={{ background: `linear-gradient(90deg, transparent, ${f.accent}, transparent)` }}
            />
            <div
              className="w-12 h-12 flex items-center justify-center rounded-sm mb-6"
              style={{ background: `${f.accent}14`, border: `1px solid ${f.accent}30` }}
            >
              <i className={`${f.icon} text-xl leading-none`} style={{ color: f.accent }} />
            </div>
            <h3 className="text-white font-bold text-lg mb-3 font-syne">{f.title}</h3>
            <p className="text-white/40 text-sm leading-relaxed font-inter">{f.desc}</p>

          </div>
        ))}
      </div>
    </section>
  );
}
